import { render, staticRenderFns } from "./PagePriceSettings.vue?vue&type=template&id=0fe3db5a&"
import script from "./PagePriceSettings.vue?vue&type=script&lang=ts&"
export * from "./PagePriceSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports